// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"messengers_scrollableContent_3w6o7","message":"messengers_message_oeGvb"};